import { useCallback, useEffect, useRef, useState } from "react";
import { apiRequest } from "../../shared/api/client";
import type { Week39PackagingSnapshot } from "./week39-types";

export function useWeek39Packaging(weekStart: string | null = "") {
  const [snapshot, setSnapshot] = useState<Week39PackagingSnapshot | null>(null);
  const [loading, setLoading] = useState(weekStart !== null);
  const [error, setError] = useState("");
  const requestId = useRef(0);

  const load = useCallback(async () => {
    const id = ++requestId.current;
    if (weekStart === null) {
      setSnapshot(null);
      setError("");
      setLoading(false);
      return;
    }
    setLoading(true);
    setError("");
    try {
      const data = await apiRequest<Week39PackagingSnapshot>(`/api/sarf39/manual-packaging${weekStart ? `?weekStart=${weekStart}` : ""}`, { cache: "no-store" });
      if (id !== requestId.current) return;
      setSnapshot(data);
    } catch (reason) {
      if (id !== requestId.current) return;
      setSnapshot(null);
      setError(reason instanceof Error ? reason.message : "Elle ambalaj planı yüklenemedi.");
    } finally {
      if (id === requestId.current) setLoading(false);
    }
  }, [weekStart]);

  useEffect(() => {
    void load();
    return () => { requestId.current += 1; };
  }, [load]);

  return { snapshot, loading, error, reload: load };
}
